<template>
  <div id="app">
    <router-view/>
    <van-tabbar v-if="$route.meta.tabbar" v-model="active" active-color="#cf2f04" inactive-color="#868686" placeholder safe-area-inset-bottom @change="onChange">
      <van-tabbar-item>
        <span>规则</span>
        <template #icon="props">
          <div class="tabber_icon tabber_rule" :class="{active:props.active}"></div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>上传</span>
        <template #icon="props">
          <div class="tabber_icon tabber_upload" :class="{active:props.active}"></div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>我的</span>
        <template #icon="props">
          <div class="tabber_icon tabber_center" :class="{active:props.active}"></div>
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <Overlay :show="show_end" class="end_box">
      <div class="wrapper">
        <div class="block">
          <div><img src="https://h5storage.xingflash.com/grcbank_sports_score_2026/images/qr.jpg?v=1" alt="" style="width: 400rem;" /></div>
          <div style="font-size: 32rem; padding: 0 20rem 20rem;">金米运动积分卡活动全新上线，积分已同步，请大家扫码登录，谢谢配合</div>
        </div>
      </div>
    </Overlay>
  </div>
</template>

<script>
let that;
import {Tabbar, TabbarItem, Dialog, Toast, Overlay} from 'vant';
export default {
  name: 'App',
  components:{
    'van-tabbar':Tabbar,
    'van-tabbar-item':TabbarItem,
    Overlay
  },
  data() {
    return {
      active: 0,
      full_hei:false,
      tip_id:null,
      show_end:true
    };
  },
  watch: {
    '$route' (to, from) { //监听路由是否变化
      // console.log(to,from);
      switch (to.name){
        case 'Upload':this.active=1;break
        case 'Center':this.active=2;break;
        default:this.active=0;
      }
    }
  },
  created() {
    that=this;
    // this.$http(this.$Global.url_base+'getData.php',{url:location.href.split('#')[0]},'POST').then(function (response) {
    //   /*console.log(response)*/
    //   var res=response.data;
    //   if(!res.status){
    //     that.$wx.config({
    //       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //       appId: res.appId, // 必填，公众号的唯一标识
    //       timestamp: res.timestamp, // 必填，生成签名的时间戳
    //       nonceStr: res.nonceStr, // 必填，生成签名的随机串
    //       signature: res.signature,// 必填，签名
    //       jsApiList: ['showAllNonBaseMenuItem','hideAllNonBaseMenuItem','showMenuItems','hideMenuItems','updateAppMessageShareData','updateTimelineShareData','onMenuShareTimeline','onMenuShareAppMessage','scanQRCode','openAddress'] // 必填，需要使用的JS接口列表
    //     });
    //     that.$wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
    //       that.$wx.hideAllNonBaseMenuItem();
    //       // that.$wx.showMenuItems({
    //       //   menuList: [
    //       //     'menuItem:share:appMessage',
    //       //     'menuItem:share:timeline'
    //       //   ]
    //       // });
    //       // that.$wx.updateAppMessageShareData({
    //       //   title: '礼遇南粤', // 分享标题
    //       //   desc: '礼遇南粤', // 分享描述
    //       //   /*link: 'http://gdnybank-shop.fengtusports.cn/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致*/
    //       //   link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //       //   imgUrl: 'http://gdnybank-shop.fengtusports.cn/static/images/banner/1.jpg', // 分享图标
    //       //   success: function () {
    //       //     // 设置成功
    //       //   }
    //       // });
    //       // that.$wx.updateTimelineShareData({
    //       //   title: '礼遇南粤', // 分享标题
    //       //   /*link: 'http://gdnybank-shop.fengtusports.cn/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致*/
    //       //   link: location.href,
    //       //   imgUrl: 'http://gdnybank-shop.fengtusports.cn/static/images/banner/1.jpg', // 分享图标
    //       //   success: function () {
    //       //     // 设置成功
    //       //   }
    //       // });
    //     });
    //   }else{
    //     console.log(res.info);
    //   }
    // }).catch(function (error) {
    //   console.log(error);
    //   /*Toast(error);*/
    // });
    /*document.addEventListener('touchstart',()=>{
      if(this.bg_count<=0){
        bg_audio.play();
        this.bg_count=1;
      }
    });*/
    let cont_hei=1440*window.innerWidth / 750;
    this.full_hei=cont_hei<window.innerHeight;
    // console.log(window.innerHeight,1440*window.innerWidth / 750);
  },
  methods:{
    onChange(index) {
      if(this.$route.meta.v_url){
        switch (index) {
          case 1:this.$router.replace('/'+this.$route.meta.v_url+'upload.html');break;
          case 2:this.$router.replace('/'+this.$route.meta.v_url+'center.html');break;
          default:this.$router.replace('/'+this.$route.meta.v_url+'rule.html');
        }
        return false;
      }
      switch (index) {
        case 1:this.$router.replace('/upload.html');break;
        case 2:this.$router.replace('/center.html');break;
        default:this.$router.replace('/rule.html');
      }
      // console.log(index );
    },
    getNotice() {
      this.$http(that.$Global.api_base+'getNotice.php',{},'POST').then(function (response) {
        /*console.log(response)*/
        var res=response.data;
        if(res.status==1){
          // that.tip_id=res.tip_id;
          Dialog.alert({
            title: '通知',
            message: res.info,
          }).then(() => {
            // on close
            that.readNotice(res.tip_id)
          });

        }
      }).catch(function (error) {
        console.log(error);
      })
    },
    readNotice(tip_id) {
      this.$http(that.$Global.api_base+'readNotice.php',{tip_id:tip_id},'POST').then(function (response) {
        /*console.log(response)*/
        var res=response.data;
        if(res.status==1){
        }
        Toast(res.info);
      }).catch(function (error) {
        console.log(error);
      })
    },
  }
}
</script>

<style>
:root {
  --index_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/index_bg.png?v=1");
  --btn_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/btn_bg.png?v=1");
  --index_tit: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/index_tit.png?v=1");
  --logo: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/logo.png?v=1");
  --login_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/login_bg.png?v=1");
  --icon_tabbar_rule: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_tabbar_rule.png?v=1");
  --icon_tabbar_rule_active: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_tabbar_rule_active.png?v=1");
  --icon_tabbar_upload: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_tabbar_upload.png?v=1");
  --icon_tabbar_upload_active: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_tabbar_upload_active.png?v=1");
  --icon_tabbar_center: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_tabbar_center.png?v=1");
  --icon_tabbar_center_active: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_tabbar_center_active.png?v=1");
  --rule_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/rule_bg.png?v=1");
  --rule_tit: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/rule_tit.png?v=1");
  --rule_txt: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/rule_txt.png?v=2");
  --icon_rule: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_rule.png?v=1");
  --upload_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/upload_bg.png?v=1");
  --upload_tit: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/upload_tit.png?v=1");
  --upload_img_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/upload_img_bg.png?v=1");
  --upload_btn_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/upload_btn_bg.png?v=1");
  --upload_icon_select: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_select.png?v=1");
  --upload_suc: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/upload_suc.png?v=1");
  --center_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/center_bg.png?v=1");
  --center_icon_weight: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/center_icon_weight.png?v=1");
  --center_icon_clear: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/center_icon_clear.png?v=1");
  --center_suc: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/center_suc.png?v=1");
}
#app{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.logo{
  background: var(--logo) no-repeat left bottom;
  background-size: 100% auto;
  width: 235rem;
  height: 65rem;
  position: absolute;
  top: 99rem;
  left: 70rem;
}
.btn{
  background: var(--btn_bg) no-repeat left bottom;
  background-size: 100% auto;
  width: 443rem;
  height: 69rem;
  line-height: 69rem;
  color: #e42f04;
  font-size: 34rem;
  text-align: center;
  font-weight: bold;
}
img{
  display: block;
}
.tabber_icon{
  width: 50rem;
  height: 50rem;
}
.tabber_rule{
  background: var(--icon_tabbar_rule) no-repeat center;
  background-size: 36rem auto;
}
.tabber_rule.active{
  background: var(--icon_tabbar_rule_active) no-repeat center;
  background-size: 36rem auto;
}
.tabber_upload{
  background: var(--icon_tabbar_upload) no-repeat center;
  background-size: 57rem auto;
}
.tabber_upload.active{
  background: var(--icon_tabbar_upload_active) no-repeat center;
  background-size: 57rem auto;
}
.tabber_center{
  background: var(--icon_tabbar_center) no-repeat center;
  background-size: 41rem auto;
}
.tabber_center.active{
  background: var(--icon_tabbar_center_active) no-repeat center;
  background-size: 41rem auto;
}
.end_box .wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.end_box .block {
  width: 400rem;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue